module.exports = __webpack_public_path__ + "static/img/shine_pic2.e2c7052.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/shine_pic2.png
// module id = kuMw
// module chunks = 1